/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  AssignBankAccountRequest,
  BadRequestErrorResponse,
  BankAccountApiResource,
  ConflictErrorResponse,
  CreatePropertyRequest,
  EditPropertyAddressRequest,
  EditPropertyRequest,
  GetApiPropertyList200,
  GetApiPropertyListParams,
  NotFoundErrorResponse,
  PropertyApiResource,
  UnauthorizedErrorResponse,
  UpdatePropertyExternalIdsRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiPropertyListResponse200 = {
  data: GetApiPropertyList200
  status: 200
}

export type getApiPropertyListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiPropertyListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiPropertyListResponseSuccess = (getApiPropertyListResponse200) & {
  headers: Headers;
};
export type getApiPropertyListResponseError = (getApiPropertyListResponse400 | getApiPropertyListResponse401 | getApiPropertyListResponse403) & {
  headers: Headers;
};

export type getApiPropertyListResponse = (getApiPropertyListResponseSuccess | getApiPropertyListResponseError)

export const getGetApiPropertyListUrl = (params?: GetApiPropertyListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/properties?${stringifiedParams}` : `/api/properties`
}

export const getApiPropertyList = async (params?: GetApiPropertyListParams, options?: RequestInit): Promise<getApiPropertyListResponse> => {
  
  return customFetch<getApiPropertyListResponse>(getGetApiPropertyListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiPropertyCreateResponse201 = {
  data: PropertyApiResource
  status: 201
}

export type postApiPropertyCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiPropertyCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiPropertyCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiPropertyCreateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type postApiPropertyCreateResponseSuccess = (postApiPropertyCreateResponse201) & {
  headers: Headers;
};
export type postApiPropertyCreateResponseError = (postApiPropertyCreateResponse400 | postApiPropertyCreateResponse401 | postApiPropertyCreateResponse403 | postApiPropertyCreateResponse409) & {
  headers: Headers;
};

export type postApiPropertyCreateResponse = (postApiPropertyCreateResponseSuccess | postApiPropertyCreateResponseError)

export const getPostApiPropertyCreateUrl = () => {


  

  return `/api/properties`
}

export const postApiPropertyCreate = async (createPropertyRequest: CreatePropertyRequest, options?: RequestInit): Promise<postApiPropertyCreateResponse> => {
  
  return customFetch<postApiPropertyCreateResponse>(getPostApiPropertyCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPropertyRequest,)
  }
);}


export type putApiPropertyEditAddressResponse200 = {
  data: PropertyApiResource
  status: 200
}

export type putApiPropertyEditAddressResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiPropertyEditAddressResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiPropertyEditAddressResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiPropertyEditAddressResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}

export type putApiPropertyEditAddressResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type putApiPropertyEditAddressResponseSuccess = (putApiPropertyEditAddressResponse200) & {
  headers: Headers;
};
export type putApiPropertyEditAddressResponseError = (putApiPropertyEditAddressResponse400 | putApiPropertyEditAddressResponse401 | putApiPropertyEditAddressResponse403 | putApiPropertyEditAddressResponse404 | putApiPropertyEditAddressResponse409) & {
  headers: Headers;
};

export type putApiPropertyEditAddressResponse = (putApiPropertyEditAddressResponseSuccess | putApiPropertyEditAddressResponseError)

export const getPutApiPropertyEditAddressUrl = (id: number,) => {


  

  return `/api/properties/${id}/address`
}

export const putApiPropertyEditAddress = async (id: number,
    editPropertyAddressRequest: EditPropertyAddressRequest, options?: RequestInit): Promise<putApiPropertyEditAddressResponse> => {
  
  return customFetch<putApiPropertyEditAddressResponse>(getPutApiPropertyEditAddressUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      editPropertyAddressRequest,)
  }
);}


export type getApiPropertyGetByIdResponse200 = {
  data: PropertyApiResource
  status: 200
}

export type getApiPropertyGetByIdResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyGetByIdResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyGetByIdResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyGetByIdResponseSuccess = (getApiPropertyGetByIdResponse200) & {
  headers: Headers;
};
export type getApiPropertyGetByIdResponseError = (getApiPropertyGetByIdResponse401 | getApiPropertyGetByIdResponse403 | getApiPropertyGetByIdResponse404) & {
  headers: Headers;
};

export type getApiPropertyGetByIdResponse = (getApiPropertyGetByIdResponseSuccess | getApiPropertyGetByIdResponseError)

export const getGetApiPropertyGetByIdUrl = (id: number,) => {


  

  return `/api/properties/${id}`
}

export const getApiPropertyGetById = async (id: number, options?: RequestInit): Promise<getApiPropertyGetByIdResponse> => {
  
  return customFetch<getApiPropertyGetByIdResponse>(getGetApiPropertyGetByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type putApiPropertyEditResponse200 = {
  data: PropertyApiResource
  status: 200
}

export type putApiPropertyEditResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiPropertyEditResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiPropertyEditResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type putApiPropertyEditResponseSuccess = (putApiPropertyEditResponse200) & {
  headers: Headers;
};
export type putApiPropertyEditResponseError = (putApiPropertyEditResponse400 | putApiPropertyEditResponse401 | putApiPropertyEditResponse403) & {
  headers: Headers;
};

export type putApiPropertyEditResponse = (putApiPropertyEditResponseSuccess | putApiPropertyEditResponseError)

export const getPutApiPropertyEditUrl = (id: number,) => {


  

  return `/api/properties/${id}`
}

export const putApiPropertyEdit = async (id: number,
    editPropertyRequest: EditPropertyRequest, options?: RequestInit): Promise<putApiPropertyEditResponse> => {
  
  return customFetch<putApiPropertyEditResponse>(getPutApiPropertyEditUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      editPropertyRequest,)
  }
);}


export type deleteApiPropertyArchiveResponse204 = {
  data: void
  status: 204
}

export type deleteApiPropertyArchiveResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiPropertyArchiveResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiPropertyArchiveResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiPropertyArchiveResponseSuccess = (deleteApiPropertyArchiveResponse204) & {
  headers: Headers;
};
export type deleteApiPropertyArchiveResponseError = (deleteApiPropertyArchiveResponse401 | deleteApiPropertyArchiveResponse403 | deleteApiPropertyArchiveResponse404) & {
  headers: Headers;
};

export type deleteApiPropertyArchiveResponse = (deleteApiPropertyArchiveResponseSuccess | deleteApiPropertyArchiveResponseError)

export const getDeleteApiPropertyArchiveUrl = (id: number,) => {


  

  return `/api/properties/${id}/archive`
}

export const deleteApiPropertyArchive = async (id: number, options?: RequestInit): Promise<deleteApiPropertyArchiveResponse> => {
  
  return customFetch<deleteApiPropertyArchiveResponse>(getDeleteApiPropertyArchiveUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


export type patchApiPropertyAssignBankAccountResponse200 = {
  data: PropertyApiResource
  status: 200
}

export type patchApiPropertyAssignBankAccountResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type patchApiPropertyAssignBankAccountResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type patchApiPropertyAssignBankAccountResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type patchApiPropertyAssignBankAccountResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type patchApiPropertyAssignBankAccountResponseSuccess = (patchApiPropertyAssignBankAccountResponse200) & {
  headers: Headers;
};
export type patchApiPropertyAssignBankAccountResponseError = (patchApiPropertyAssignBankAccountResponse400 | patchApiPropertyAssignBankAccountResponse401 | patchApiPropertyAssignBankAccountResponse403 | patchApiPropertyAssignBankAccountResponse404) & {
  headers: Headers;
};

export type patchApiPropertyAssignBankAccountResponse = (patchApiPropertyAssignBankAccountResponseSuccess | patchApiPropertyAssignBankAccountResponseError)

export const getPatchApiPropertyAssignBankAccountUrl = (id: number,) => {


  

  return `/api/properties/${id}/bank-account/assign`
}

export const patchApiPropertyAssignBankAccount = async (id: number,
    assignBankAccountRequest: AssignBankAccountRequest, options?: RequestInit): Promise<patchApiPropertyAssignBankAccountResponse> => {
  
  return customFetch<patchApiPropertyAssignBankAccountResponse>(getPatchApiPropertyAssignBankAccountUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      assignBankAccountRequest,)
  }
);}


export type getApiPropertyBankAccountsListResponse200 = {
  data: BankAccountApiResource[]
  status: 200
}

export type getApiPropertyBankAccountsListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyBankAccountsListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyBankAccountsListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyBankAccountsListResponseSuccess = (getApiPropertyBankAccountsListResponse200) & {
  headers: Headers;
};
export type getApiPropertyBankAccountsListResponseError = (getApiPropertyBankAccountsListResponse401 | getApiPropertyBankAccountsListResponse403 | getApiPropertyBankAccountsListResponse404) & {
  headers: Headers;
};

export type getApiPropertyBankAccountsListResponse = (getApiPropertyBankAccountsListResponseSuccess | getApiPropertyBankAccountsListResponseError)

export const getGetApiPropertyBankAccountsListUrl = (id: number,) => {


  

  return `/api/properties/${id}/bank-accounts`
}

export const getApiPropertyBankAccountsList = async (id: number, options?: RequestInit): Promise<getApiPropertyBankAccountsListResponse> => {
  
  return customFetch<getApiPropertyBankAccountsListResponse>(getGetApiPropertyBankAccountsListUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type putApiPropertyUpdateExternalIdsResponse200 = {
  data: PropertyApiResource
  status: 200
}

export type putApiPropertyUpdateExternalIdsResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiPropertyUpdateExternalIdsResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiPropertyUpdateExternalIdsResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiPropertyUpdateExternalIdsResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}

export type putApiPropertyUpdateExternalIdsResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type putApiPropertyUpdateExternalIdsResponseSuccess = (putApiPropertyUpdateExternalIdsResponse200) & {
  headers: Headers;
};
export type putApiPropertyUpdateExternalIdsResponseError = (putApiPropertyUpdateExternalIdsResponse400 | putApiPropertyUpdateExternalIdsResponse401 | putApiPropertyUpdateExternalIdsResponse403 | putApiPropertyUpdateExternalIdsResponse404 | putApiPropertyUpdateExternalIdsResponse409) & {
  headers: Headers;
};

export type putApiPropertyUpdateExternalIdsResponse = (putApiPropertyUpdateExternalIdsResponseSuccess | putApiPropertyUpdateExternalIdsResponseError)

export const getPutApiPropertyUpdateExternalIdsUrl = (id: number,) => {


  

  return `/api/properties/${id}/external-ids`
}

export const putApiPropertyUpdateExternalIds = async (id: number,
    updatePropertyExternalIdsRequest: UpdatePropertyExternalIdsRequest, options?: RequestInit): Promise<putApiPropertyUpdateExternalIdsResponse> => {
  
  return customFetch<putApiPropertyUpdateExternalIdsResponse>(getPutApiPropertyUpdateExternalIdsUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updatePropertyExternalIdsRequest,)
  }
);}


